module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [_c('div', {
    staticClass: "pop-mask"
  }, [_c('div', {
    staticClass: "pop-wrapper"
  }, [_c('div', {
    staticClass: "pop-container"
  }, [_c('font-awesome-icon', {
    staticClass: "icon close-btn",
    attrs: {
      "size": "2x",
      "icon": ['fas', 'times']
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pop-body"
  }, [_vm._t("table")], 2)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c64f2b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/tw/record/Popup.vue
// module id = 755
// module chunks = 3